module.exports = __webpack_public_path__ + "img/grin-squint-tears.bf6c953a.svg";